export default __webpack_public_path__ + "favicon.b7bcd427.ico";